import React from 'react';
import './DeviceTypeChip.css';

const DeviceTypeChip = ({ productType, size }) => {
  return (
    <div className={`DeviceTypeChip_${size}`} data-tip={productType}>
      {productType}
    </div>
  );
};

export default DeviceTypeChip;
